import * as React from "react"

import type { BreadcrumbCrumb } from "@/utils/breadcrumbPageTitle"

type ShadcnInsetBreadcrumbContextValue = {
  trailOverride: BreadcrumbCrumb[] | null
  setTrailOverride: (trail: BreadcrumbCrumb[] | null) => void
}

const ShadcnInsetBreadcrumbContext =
  React.createContext<ShadcnInsetBreadcrumbContextValue | null>(null)

export function ShadcnInsetBreadcrumbProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [trailOverride, setTrailOverride] = React.useState<BreadcrumbCrumb[] | null>(
    null
  )
  const value = React.useMemo(
    () => ({ trailOverride, setTrailOverride }),
    [trailOverride]
  )
  return (
    <ShadcnInsetBreadcrumbContext.Provider value={value}>
      {children}
    </ShadcnInsetBreadcrumbContext.Provider>
  )
}

export function useShadcnInsetBreadcrumbContext() {
  const ctx = React.useContext(ShadcnInsetBreadcrumbContext)
  if (!ctx) {
    return {
      trailOverride: null as BreadcrumbCrumb[] | null,
      setTrailOverride: (_trail: BreadcrumbCrumb[] | null) => {},
    }
  }
  return ctx
}
